// src/constants.js

export const COURSE_PRICE = 1100; // Set the course price here
const ORIGINAL_PRICE = 2000; // Original price in INR
const DISCOUNT_PERCENTAGE = 45; // Discount percentage
